'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
require('styled-components');
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
require('../settings-9ee2f03f.js');
require('../browser-05a2bba8.js');
require('react-dom');
require('../_commonjsHelpers-3fc1f64e.js');
require('../_react_commonjs-external-30e5c7b3.js');
require('../_prop-types_commonjs-external-c51b2bd5.js');
var styles = require('../styles-e130111c.js');
require('../index-45be2fcd.js');
require('../invariant-8c441586.js');
require('../react-lifecycles-compat.es-59afd828.js');
require('../_react-dom_commonjs-external-3c49a59a.js');

var DropdownMenuWithCircleHover = function (_Component) {
  _babelHelpers.inherits(DropdownMenuWithCircleHover, _Component);

  function DropdownMenuWithCircleHover(props) {
    _babelHelpers.classCallCheck(this, DropdownMenuWithCircleHover);

    var _this = _babelHelpers.possibleConstructorReturn(this, (DropdownMenuWithCircleHover.__proto__ || Object.getPrototypeOf(DropdownMenuWithCircleHover)).call(this, props));

    _this.renderMenuItem = _this.renderMenuItem.bind(_this);
    return _this;
  }

  _babelHelpers.createClass(DropdownMenuWithCircleHover, [{
    key: "renderMenuItem",
    value: function renderMenuItem() {
      var _props = this.props,
          menuItems = _props.menuItems,
          minHeight = _props.minHeight,
          _props$hideLabel = _props.hideLabel,
          hideLabel = _props$hideLabel === undefined ? false : _props$hideLabel;

      return menuItems.map(function (menuItem) {
        return menuItem.divider ? React__default.createElement(styles.StyledDivider, { key: "menuItem-divider", divider: true }) : React__default.createElement(
          styles.StyledMenuItem,
          {
            id: "" + menuItem.id,
            key: "menuItem-" + menuItem.label,
            onClick: function onClick(e) {
              menuItem.onClick(e);
              e.stopPropagation();
            },
            redText: menuItem.redText,
            minHeight: minHeight },
          menuItem.icon && menuItem.icon(),
          !hideLabel && menuItem.label
        );
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          toggleBtnId = _props2.toggleBtnId,
          bsSize = _props2.bsSize,
          loading = _props2.loading,
          noCaret = _props2.noCaret,
          disabled = _props2.disabled,
          menuItems = _props2.menuItems,
          MenuComponent = _props2.MenuComponent,
          ToggleComponent = _props2.ToggleComponent,
          DropdownToggleComponent = _props2.DropdownToggleComponent,
          margin = _props2.margin,
          customMobileStyle = _props2.customMobileStyle,
          backgroundColor = _props2.backgroundColor,
          hideVisibility = _props2.hideVisibility,
          minWidth = _props2.minWidth;


      return React__default.createElement(
        styles.StyledDropdownWithCircleHover,
        {
          pullRight: true,
          margin: margin,
          id: id,
          disabled: disabled,
          backgroundColor: backgroundColor,
          hideVisibility: hideVisibility,
          customMobileStyle: customMobileStyle,
          rootCloseEvent: "click",
          minWidth: minWidth },
        DropdownToggleComponent ? React__default.createElement(DropdownToggleComponent, { bsRole: "toggle" }) : React__default.createElement(
          styles.Dropdown.Toggle,
          {
            noCaret: noCaret,
            bsSize: bsSize,
            id: toggleBtnId,
            onClick: function onClick(e) {
              e.preventDefault();
              e.stopPropagation();
            } },
          loading ? React__default.createElement(
            "div",
            { className: "spin-loader" },
            React__default.createElement("i", { className: "fa fa-circle-notch fa-spin" })
          ) : React__default.createElement(ToggleComponent, null)
        ),
        React__default.createElement(
          styles.Dropdown.Menu,
          null,
          menuItems && this.renderMenuItem(),
          MenuComponent && React__default.createElement(MenuComponent, null)
        )
      );
    }
  }]);
  return DropdownMenuWithCircleHover;
}(React.Component);

DropdownMenuWithCircleHover.propTypes = {
  /** component id */
  id: PropTypes$1.string.isRequired,
  /** toggle button id */
  toggleBtnId: PropTypes$1.string.isRequired,
  /** indicator to display disabled state */
  disabled: PropTypes$1.bool,
  /** use for add margin to component example "10px 10px 10px 10px" */
  margin: PropTypes$1.string,
  /** indicator for bootstrap dropdown menu size */
  bsSize: PropTypes$1.oneOf(["small", "large", "xsmall", undefined]),
  /** indicator to show caret */
  noCaret: PropTypes$1.bool,
  /** Component use to open and close dropdown */
  DropdownToggleComponent: PropTypes$1.func,
  /** Component use as a button to open and close dropdown */
  ToggleComponent: PropTypes$1.func,
  /** Menu of the dropdown */
  MenuComponent: PropTypes$1.func,
  /** Array of menu item */
  menuItems: PropTypes$1.arrayOf(PropTypes$1.shape({
    /** onClick function of the menu */
    onClick: PropTypes$1.func,
    /** menu label */
    label: PropTypes$1.string,
    /** indicator to display label text in red color */
    redText: PropTypes$1.bool,
    /** indicator to display the item as divider */
    divider: PropTypes$1.bool,
    /** icon of the menu */
    icon: PropTypes$1.func
  })),
  /** use for custom mobile style to component example
   * `
   *  position: absolute;
   *  margin: 0px;
   *  right: 32px;
   * `
   */
  customMobileStyle: PropTypes$1.string,
  /** indicator to hide the component NOTE: this props only hide visibility of the component but the margin and stuff are still have an effect */
  hideVisibility: PropTypes$1.bool,
  /** minimum width of dropdown menu example "120px" */
  minWidth: PropTypes$1.string,
  /** minimum height of dropdown menu example "36px" */
  minHeight: PropTypes$1.string,
  /** indicator to display label text dropdown menu or not */
  hideLabel: PropTypes$1.bool
};
DropdownMenuWithCircleHover.defaultProps = {
  disabled: false,
  noCaret: true
};
DropdownMenuWithCircleHover.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "renderMenuItem",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "DropdownMenuWithCircleHover",
  "props": {
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator to display disabled state"
    },
    "noCaret": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator to show caret"
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "component id"
    },
    "toggleBtnId": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "toggle button id"
    },
    "margin": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "use for add margin to component example \"10px 10px 10px 10px\""
    },
    "bsSize": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"small\"",
          "computed": false
        }, {
          "value": "\"large\"",
          "computed": false
        }, {
          "value": "\"xsmall\"",
          "computed": false
        }, {
          "value": "undefined",
          "computed": true
        }]
      },
      "required": false,
      "description": "indicator for bootstrap dropdown menu size"
    },
    "DropdownToggleComponent": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Component use to open and close dropdown"
    },
    "ToggleComponent": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Component use as a button to open and close dropdown"
    },
    "MenuComponent": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Menu of the dropdown"
    },
    "menuItems": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "onClick": {
              "name": "func",
              "description": "onClick function of the menu",
              "required": false
            },
            "label": {
              "name": "string",
              "description": "menu label",
              "required": false
            },
            "redText": {
              "name": "bool",
              "description": "indicator to display label text in red color",
              "required": false
            },
            "divider": {
              "name": "bool",
              "description": "indicator to display the item as divider",
              "required": false
            },
            "icon": {
              "name": "func",
              "description": "icon of the menu",
              "required": false
            }
          }
        }
      },
      "required": false,
      "description": "Array of menu item"
    },
    "customMobileStyle": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "use for custom mobile style to component example\n`\n position: absolute;\n margin: 0px;\n right: 32px;\n`"
    },
    "hideVisibility": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator to hide the component NOTE: this props only hide visibility of the component but the margin and stuff are still have an effect"
    },
    "minWidth": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "minimum width of dropdown menu example \"120px\""
    },
    "minHeight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "minimum height of dropdown menu example \"36px\""
    },
    "hideLabel": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator to display label text dropdown menu or not"
    }
  }
};

module.exports = DropdownMenuWithCircleHover;
//# sourceMappingURL=dropdown-menu-with-circle-hover.js.map
